import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../constants/constants';
export const componentKey = "MANAGE_CARDS";

const initialState = {
    stripeSavedCardsList: [],
    loadingState: { state: PAGE_STATE.PRE_LOADING, message: "" },
    newCardDetails: {},
    setNewCardAddSuccess: false,
    selectedCard: null,
};
const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setStripeSavedCardsList : (state, action) => {
            state.stripeSavedCardsList = action.payload;
        },
        setLoadingState : (state, action) => {
            state.loadingState = action.payload;
        },
        setNewCardDetails: (state, action) => {
            state.newCardDetails = action.payload;
        },
        setAddNewCard: (state, action) => {
            state.isAddNewCard = action.payload;
        },
        setSelectedCard: (state, action) => {
            state.selectedCard = action.payload;
        },
    },
    initialReducerState: initialState
});
export const { setLoadingState, setSelectedCard, setStripeSavedCardsList, setNewCardDetails, setAddNewCard } = actions;